export enum Operations {
  SUBMIT,
  DELETE,
}
